<app-search-widget-toppage-wrapper
  [pageType]="pageType"
></app-search-widget-toppage-wrapper>

<div class="narrowed-container">
  <div class="row">
    <div class="col">
      <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <h1
        class="my-6 text-3xl font-bold text-grey-1 md:text-4xl"
        id="blog-header"
      >
        {{ pageTitle }}
      </h1>
      <app-native-list-post
        *ngFor="let post of posts; let i = index; trackBy: trackByMethod"
        [index]="i"
        [post]="post"
      ></app-native-list-post>

      <app-pagination
        *ngIf="posts && posts.length > 0"
        [baseUrlTab]="baseUrl"
        [currentPage]="urlResolver.page"
        [maxLength]="10"
        [pageParameterName]="'page'"
        [pageSize]="pageSize"
        [total]="total"
      >
      </app-pagination>
    </div>
    <div class="col-s">
      <app-sidebar
        *ngIf="loadedCpruTypes === true"
        [isAdVisible]="true"
        [pageType]="pageType"
      ></app-sidebar>
    </div>
  </div>
</div>
